
<label class="slider-checkbox">
  <input
    type="checkbox"
    :checked="value"
    @change="$emit('input', $event.target.checked)"
  />
  <span class="slider rounded-full" :class="{ 'slider-checked': value }">
    <span class="slider-circle"></span>
  </span>
</label>
